import { get } from 'lodash';
import React, { Component } from 'react';
import { ERROR_CODES } from '@upsolve/shared';

import Wrapper from './styled/Wrapper.div';
import HintWrapper from './styled/HintWrapper.div';
import HintCard from './styled/HintCard.div';
import ScreenerButton from './styled/ScreenerButton.button';
import ChatBubbleIcon from '../../../static/images/icon-chat-bubble.svg';
import { H4 } from '../Type/Display.h';
import P from '../Type/Paragraph.p';
import { Button, ButtonLink } from '../Inputs/Button.span';
import Input from '../Inputs/Input.input';
import submitLead from '../Leads/submitLead';
import { withAmp } from '../AMP/AmpContext';
import TermsCopy from '../terms/TermsCopy';

class ChatWidget extends Component {
  constructor(props) {
    super(props);
    this.showForm = this.showForm.bind(this);
    this.state = {
      // UI
      show: false,
      hint: false,
      form: false,
      // Lead capture
      filer: {
        name: null,
        email: null,
        phoneNumber: null,
        zipcode: null,
      },
      success: false,
      error: null,
      submitted: false,
    };
  }

  componentDidMount() {
    // Don't hint if already hinted recently
    if (window != null && (localStorage.getItem('Upsolve.widgetHinted') == null
      || (Number(localStorage.getItem('Upsolve.widgetHinted')) + 20000) < new Date().getTime()
    )) {
      setTimeout(() => {
        // Check if form isn't already open
        // if (this.state.form !== true) this.setState(prevState => ({ ...prevState, show: true, hint: true, form: false }));
      }, 30000);
    }
    // Only reveal if we've scrolled
    window.addEventListener('scroll', () => {
      const offset = window.pageYOffset;
      if (offset > (window.innerHeight * 1.25) && this.state.show === false) {
        this.setState(prevState => ({ ...prevState, show: true }));
      }
    });
  }

  showHint() {
    this.setState(prevState => ({ ...prevState, hint: true, form: false }));
  }

  hideHint() {
    this.setState(prevState => ({ ...prevState, hint: false, form: false }));
  }

  showForm() {
    this.setState(prevState => ({ ...prevState, hint: true, form: true }));
    if (window != null) localStorage.setItem('Upsolve.widgetHinted', new Date().getTime());
  }

  updateHelper(key, value) {
    this.setState(prevState => ({
      ...prevState,
      filer: {
        ...prevState.filer,
        [key]: value,
      },
    }));
  }

  async submitHelper() {
    // Don't run if we've already submitted
    if (this.state.success === true) return;
    // Otherwise try it out
    const { filer } = this.state;
    this.setState(prevState => ({ ...prevState, submitted: true }));
    try {
      await submitLead({
        type: 'bankruptcy',
        name: filer.name,
        email: filer.email,
        phoneNumber: filer.phoneNumber,
        zipcode: filer.zipcode,
      });
      this.setState(prevState => ({ ...prevState, error: null, success: true, submitted: false }));
    } catch (e) {
      this.setState(prevState => ({
        ...prevState,
        error: get(e.response, 'data.error') || { message: 'An error was hit, please try submitting again.' },
        submitted: false,
      }));
    }
  }

  render() {
    const { amp } = this.props;
    const { error } = this.state;

    return amp === true
      ? (
        <a href="https://my.upsolve.org/screener">
          <ScreenerButton className="slide-in">
            <ChatBubbleIcon />
            <a href="https://my.upsolve.org/screener">
              {this.props.persistentCtaText || 'Get Free Help'}
            </a>
          </ScreenerButton>
        </a>
      )
      : (
        <Wrapper className={this.props.showPersistentCta !== true ? 'hide' : ''}>
          <HintWrapper className={`${this.state.hint === true ? 'show-hint' : ''} ${this.state.form === true ? 'show-form' : ''}`}>
            <div className="hint__author" />
            <div
              className="hint__clear"
              onClick={(e) => {
                e.preventDefault();
                this.hideHint();
              }}
            >
              Close
            </div>
            <HintCard>
              {this.state.form === false
                ? <H4>Considering Bankruptcy?</H4>
                : <H4>Get One-On-One Help</H4>}
              {this.state.form === false && (
                <div className="value-props">
                  <P>
                    Are you interested in our free bankruptcy services, talking to someone about alternatives to bankruptcy, or a free consultation with a paid attorney?
                  </P>
                  <div>
                    <ButtonLink aria-busy="false" href="https://my.upsolve.org/screener">I want a Free Bankruptcy Service</ButtonLink>
                  </div>
                  <div>
                    <ButtonLink aria-busy="false" href="/find-a-credit-counselor">I want a Free Counseling Session</ButtonLink>
                  </div>
                  <div>
                    <Button name="I want a Private Attorney" aria-label="I want a Private Attorney" onClick={() => this.showForm()}>I want a Private Attorney</Button>
                  </div>
                </div>
              )}
              {this.state.form === true && (
                <div className="value-props">
                  <p>
                    Enter your info below to get a <u>free consultation</u> with a paid attorney. You will always be able to use our <a href="https://my.upsolve.org/screener">free service</a>.
                  </p>
                </div>
              )}
              {this.state.form === true && (
                <form
                  role="form"
                  className="lead-capture"
                  onSubmit={(e) => {
                    e.preventDefault();
                    this.submitHelper();
                  }}
                >
                  <div>
                    <label>
                      First and Last Name
                      <Input type="text" disabled={this.state.success === true} onChange={e => this.updateHelper('name', e.target.value)} />
                    </label>
                    <label>
                      Email
                      <Input type="text" disabled={this.state.success === true} onChange={e => this.updateHelper('email', e.target.value)} />
                    </label>
                    <label>
                      Phone Number
                      <Input type="text" disabled={this.state.success === true} onChange={e => this.updateHelper('phoneNumber', e.target.value)} />
                    </label>
                    <label>
                      Zipcode
                      <Input type="text" disabled={this.state.success === true} onChange={e => this.updateHelper('zipcode', e.target.value)} />
                    </label>
                    {error != null && <div className="lead-capture__form__error">
                      {error.code === ERROR_CODES.INVALID_EMAIL && <P>Please enter a valid email so we can send you information to help.</P>}
                      {error.code === ERROR_CODES.INVALID_PHONE_NUMBER && <P>Please enter a valid US phone number so we can get you in touch with help.</P>}
                      {error.code === ERROR_CODES.INVALID_ZIPCODE && <P>Please enter a valid zipcode so we can find nearby help.</P>}
                      {error.code === ERROR_CODES.FILER_EXISTS && <P>It looks like we already have your information on file!</P>}
                      {error.code == null && <P>There was an error. Please check your information and try again.</P>}
                    </div>}
                    {this.state.success === true && <div className="lead-capture__form__success">
                      <b>Great!</b> You will receive more information from our partners soon.
                      </div>}
                  </div>
                  <Button
                    aria-busy="false"
                    disabled={this.state.success === true || this.state.submitted === true}
                    width="100%"
                    size="lg"
                    type="submit"
                    buttonType={this.state.success === true ? 'success' : ''}
                  >
                    Connect to Help
                  </Button>
                  <br />
                  <TermsCopy />
                </form>
              )}
            </HintCard>
          </HintWrapper>
          {(this.state.form === false && this.state.hint === false) && (
            <ScreenerButton
              aria-busy="false"
              aria-label={this.props.persistentCtaText || 'Get Free Help'}
              className={this.state.show === true ? 'slide-in' : ''}
              onClick={() => this.showHint()}
            >
              <ChatBubbleIcon />
              {this.props.persistentCtaText || 'Get Free Help'}
            </ScreenerButton>
          )}
        </Wrapper>
      );
  }
}

export default withAmp(ChatWidget);
